export type ConversationLayoutNode =
  | { kind: 'pane'; id: string }
  | {
      kind: 'split';
      id: string;
      orientation: 'horizontal' | 'vertical';
      first: ConversationLayoutNode;
      second: ConversationLayoutNode;
    };

export type ConversationDockSide = 'left' | 'right' | 'top' | 'bottom';

export type ConversationDockPreview = {
  side: ConversationDockSide;
  targetId: string;
  left: number;
  top: number;
  width: number;
  height: number;
};

export function layoutHasPane(node: ConversationLayoutNode, paneId: string): boolean {
  return node.kind === 'pane'
    ? node.id === paneId
    : layoutHasPane(node.first, paneId) || layoutHasPane(node.second, paneId);
}

export function replaceLayoutPane(
  node: ConversationLayoutNode,
  paneId: string,
  nextPaneId: string,
): ConversationLayoutNode {
  if (node.kind === 'pane') return node.id === paneId ? { kind: 'pane', id: nextPaneId } : node;
  return {
    ...node,
    first: replaceLayoutPane(node.first, paneId, nextPaneId),
    second: replaceLayoutPane(node.second, paneId, nextPaneId),
  };
}

export function dockLayoutPane(
  node: ConversationLayoutNode,
  targetId: string,
  paneId: string,
  side: ConversationDockSide,
): ConversationLayoutNode {
  if (node.kind === 'pane') {
    if (node.id !== targetId) return node;
    const inserted: ConversationLayoutNode = { kind: 'pane', id: paneId };
    const before = side === 'left' || side === 'top';
    return {
      kind: 'split',
      id: crypto.randomUUID(),
      orientation: side === 'left' || side === 'right' ? 'horizontal' : 'vertical',
      first: before ? inserted : node,
      second: before ? node : inserted,
    };
  }
  return {
    ...node,
    first: dockLayoutPane(node.first, targetId, paneId, side),
    second: dockLayoutPane(node.second, targetId, paneId, side),
  };
}

export function removeLayoutPane(
  node: ConversationLayoutNode,
  paneId: string,
): ConversationLayoutNode | null {
  if (node.kind === 'pane') return node.id === paneId ? null : node;
  const first = removeLayoutPane(node.first, paneId);
  const second = removeLayoutPane(node.second, paneId);
  if (first === null) return second;
  if (second === null) return first;
  return { ...node, first, second };
}
